import React, {Component, Fragment} from 'react';
import Navbar from "../common/navbar/Navbar";
import {ADMIN} from "../../actions/types";
import {connect} from "react-redux";
import {Row, Col} from 'reactstrap';
import {
    actionGetPermissions,
    actionGetRole,
    actionGetSingleRoleDetails,
    actionGetUserById,
    actionUpdateUserById
} from "../../actions/profile";
import {register} from "../../actions/auth";
import HeroSection from "../common/HerroSection/hero-section";
import CommanSidebar from "../common/commanSidebar";

class viewProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: '',
            mobile: '',
            password: '',
            permission: [],
            userData: '',
            errors: {}
        }
    }

    componentDidMount() {
        this.props.actionGetRole();
        this.props.actionGetPermissions();

        if (this.props.match.params.id) {
            this.props.actionGetUserById(this.props.match.params.id);
        }

    }

    componentDidUpdate(prevProps, prevState) {
        prevProps.singlUser !== this.props.singlUser && this.setState({userData: this.props.singlUser});

        if (prevProps.singleRoleDetails !== this.props.singleRoleDetails) {
            ((this.props.singleRoleDetails && this.props.singleRoleDetails.permissions) && this.props.singleRoleDetails.permissions.length > 0) && this.setState({
                permission: this.props.singleRoleDetails.permissions
            });
        }
    }

    render() {
        const {userData} = this.state;
        return (
            <Fragment>
                <CommanSidebar/>
                <div className="content">
                    <Row className="d-flex justify-content-around mt-2">
                        <Col xl={2}/>
                        <Col lg={6} xl={4}>
                            <div className="cards  card-hover m-3">
                                <h3 className="mb-1">Basic Info</h3>
                                <table className="table striped bordered hover">
                                    <tr>
                                        <th>Name:</th>
                                        <td>{userData.name ? userData.name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Email:</th>
                                        <td>{userData.email ? userData.email : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Mobile:</th>
                                        <td>{userData.mobile ? userData.mobile : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Gender:</th>
                                        <td>{userData.gender ? (userData.gender === 'M' ? 'Male' : 'Female') : '-'}</td>
                                    </tr>
                                </table>
                            </div>
                        </Col>
                        <Col lg={6} xl={4}>
                            <div className="cards card-hover m-3">
                                <h3 className="mb-1">Address</h3>
                                <table className="table">
                                    <tr>
                                        <th>Country:</th>
                                        <td>{userData.country ? userData.country.name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>State:</th>
                                        <td>{userData.state ? userData.state.name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>City:</th>
                                        <td>{userData.city ? userData.city.name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Zip Code:</th>
                                        <td>{userData.zip_code ? userData.zip_code : '-'}</td>
                                    </tr>
                                </table>
                            </div>
                        </Col>
                        <Col xl={2}/>
                    </Row>
                    <Row className="d-flex justify-content-around mt-2">
                        <Col xl={2}/>
                        <Col lg={6} xl={4}>
                            <div className="cards card-hover m-3">
                                <h3 className="mb-1">Company Info</h3>
                                <table className="table striped bordered hover">
                                    <tr>
                                        <th>Name:</th>
                                        <td>{userData.company_name ? userData.company_name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Company Team Name:</th>
                                        <td>{userData.company_team_name ? userData.company_team_name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Designations:</th>
                                        <td>{userData.designations ? userData.designations : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Cites Expert:</th>
                                        <td>{userData.cites_expert ? userData.cites_expert : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Subdivisions Expert:</th>
                                        <td>{userData.cites_expert ? userData.cites_expert : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Address:</th>
                                        <td>{userData.cites_expert ? userData.cites_expert : '-'}</td>
                                    </tr>
                                </table>
                            </div>
                        </Col>
                        <Col lg={6} xl={4}>
                            <div className="cards card-hover m-3">
                                <h3 className="mb-1">Personal Info</h3>
                                <table className="table">
                                    <tr>
                                        <th>Hobbies:</th>
                                        <td>{userData.hobbies ? userData.hobbies : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Number Of Years In Business:</th>
                                        <td>{userData.number_of_years_in_business ? userData.number_of_years_in_business : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Languages Spoken:</th>
                                        <td>{userData.languages_spoken ? userData.languages_spoken : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Connections:</th>
                                        <td>{userData.country ? userData.friends.length : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Facebook:</th>
                                        <td>{userData.facebook ? userData.facebook : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Instagram:</th>
                                        <td>{userData.instagram ? userData.instagram : '-'}</td>
                                    </tr>
                                    <tr>
                                        <th>Twitter:</th>
                                        <td>{userData.twitter ? userData.twitter : '-'}</td>
                                    </tr>
                                </table>
                            </div>
                        </Col>
                        <Col xl={2}/>
                    </Row>
                </div>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    singlUser: state.profile.singlUser,
    role: state.profile.role,
    roleLoader: state.profile.roleLoader,
    singleRoleDetails: state.profile.singleRoleDetails,
    permissions: state.profile.permissions,
    permissionLoader: state.profile.permissionLoader,
    user: state.auth.user
});


export default connect(mapStateToProps, {
    actionGetRole,
    register,
    actionGetUserById,
    actionUpdateUserById,
    actionGetSingleRoleDetails,
    actionGetPermissions
})(viewProfile);
